import { Component, Input } from '@angular/core';
import { AreaComum } from '../../models/area';
import { AtalhoConversa } from '../shared/abstract/atalho-conversa';
import { BrComDao } from '../../service/BrComDao';
import { FotoProvider } from '../../providers/foto/foto';
import { NavProxyProvider } from '../../providers/nav-proxy/nav-proxy';
import { ConversaAreaPage } from '../../pages/conversa-area/conversa-area';

@Component({
  selector: 'conversa-area',
  templateUrl: 'conversa-area.html'
})
export class ConversaAreaComponent extends AtalhoConversa {

  @Input() area: AreaComum;
  private idUsuario: number;

  constructor(private brComDAO: BrComDao, 
    private fotoProvider: FotoProvider,
    private navProxyProvider: NavProxyProvider) {
    super();
    this.idUsuario = this.brComDAO.getEmpresa().IdUsuario;
  }

  ngOnInit() {
    this.atualizarUltimaMensagem(this.area.mensagens);
 //   this.isAdmin = this.isUsuarioAdmin();
  }

  protected atualizarNumMensagensNaoLidas(): void {
    const mensagens = this.area.mensagens;
    if (mensagens) {
      //filtra todas as mensagens que foram enviadas ao usuário e não foram lidas
      this._quantidadeMensagensNaoLidas = mensagens.filter(m => m.origem === "L"
        && !m.statusMensagemLida).length;
    }
  }

  public abrirConversa(): void {
    this.navProxyProvider.pushContent(ConversaAreaPage, {
      area: this.area
    })
  };

  public isUsuarioAdmin(): boolean {
    const idAdmins = this.area.idAdministradores || [];
    for (const idAdmin of idAdmins) {
      if (idAdmin === this.idUsuario) {
        return true;
      }
    }
    return false;
  }

  public getFotoPerfil(): string {
    if (this.area.hashImagem === "" || !this.area.hashImagem) {
      return "assets/img/usuario.png";
    }
    return this.fotoProvider.getUrlImagemServidor(this.area.hashImagem);
  }

}



// WEBPACK FOOTER //
// ./src/components/conversa-area/conversa-area.ts